import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDisplayToastStore } from '../../../../../redux/display/display/displayHooks';
import './DisplayToastContainer.css';

/** Transient, non-blocking toast strip — no backdrop, doesn't intercept page interaction.
 *  Aligned with Product Catalog's toast (pill, bottom-center, auto-dismiss). */
export function DisplayToastContainer() {
  const { toasts, removeToast } = useDisplayToastStore();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || toasts.length === 0) return null;

  const node = (
    <div className="display-toast-wrap" aria-live="polite">
      {toasts.map((toast) => (
        <div key={toast.id} className={`display-toast-item is-${toast.type}`}>
          <span className="display-toast-message">{toast.message}</span>

          <button
            type="button"
            onClick={() => removeToast(toast.id)}
            className="display-toast-dismiss"
            aria-label="Close toast"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );

  return createPortal(node, document.body);
}
